import type { RouteLocationRaw } from 'vue-router'
import type { Notification } from '../types/notifications.types'

/**
 * Куда вести по клику на уведомление в кабинете агента. Навигация — по явному
 * `metadata.url` (его кладёт издатель события; для просмотра презентации это
 * `/presentations/{id}`). Возвращает `null`, если переходить некуда.
 */
export function buildNotificationRoute(notification: Notification): RouteLocationRaw | null {
  const meta = notification.metadata ?? {}
  const url = meta.url as string | undefined
  return url ?? null
}
